import { IdentityDocumentType as IdentityDocumentTypeEnum } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

function IdentityDocumentType() {}

enumify<IdentityDocumentTypeEnum, number>(IdentityDocumentType, 'IdentityDocumentType', {
    Passport: 0,
    IdentityCard: 1,
    DriversLicense: 2,
    Visa: 3,
});

export default IdentityDocumentType as unknown as Enumify<IdentityDocumentTypeEnum, number>;
